<template>
	<v-card class="hero-card rounded-lg" :style="background">
		<h1>
			<slot>
				CARRERAS KINESIA
				<!-- <sup><span class="code accent--text">[BETA]</span></sup> -->
			</slot>
		</h1>
		<p>La nueva forma de correr</p>

		<v-btn
			v-if="deferredPrompt"
			@click="$emit('install-app')"
			color="accent"
			x-large
			elevation="0"
			class="install-button rounded-lg"
			>Instalar APP</v-btn
		>

		<!-- <v-btn
			v-else
			color="accent"
			large
			elevation="0"
			:to="{ name: 'MyRaces' }"
			class="my-races-button rounded-lg"
			>Ir a mis carreras</v-btn
		> -->
	</v-card>
</template>

<script>
export default {
	props: {
		deferredPrompt: {
			type: Object,
			default: null,
		},
		color1: {
			type: String,
			default: "rgba(15,15,22,0.75)",
		},
		color2: {
			type: String,
			default: "rgba(15,15,22,0.8)",
		},
		image: Boolean,
	},
	computed: {
		background() {
			if (this.image) {
				return {
					background: `linear-gradient( ${this.color1} 0%, ${this.color2} 100%), ${this.imgSrc}`,
					"background-position": " 50% 90%",
					"background-size": "cover",
				};
			} else {
				return {
					background: `linear-gradient(90deg, ${this.color1} 0%, ${this.color2} 100%)`,
				};
			}
		},
		imgSrc() {
			return `url("${require("../../assets/User/running.jpg")}")`;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../scss/_mixins.scss";

.hero-card {
	display: flex;
	min-height: 350px;
	align-items: flex-start;
	justify-content: center;
	padding: 1.5em;
	width: 100%;
	flex-direction: column;

	@include desktop() {
		padding: 4em;
	}

	h1 {
		font-size: 2.5em;
		color: #fff;
		text-align: left;
		line-height: 1.3em;
		transform: translateX(-0.05em);

		@include desktop() {
			font-size: 5em;
			line-height: initial;
		}
	}

	p {
		color: #fff;
		font-size: 1.5em;

		margin-bottom: 0.3em;

		@include desktop() {
			margin-top: -0.5em;
		}
	}

	.install-button,
	.my-races-button {
		position: absolute;
		right: 2em;
		bottom: 2em;
	}
}
</style>

<style lang="scss">
.code {
	font-family: monospace;
	font-weight: 400;
}
</style>
